import React, { useState } from "react";
import SplitBillModal from "../modals/SplitBillModal";
import NewGroupModal from "../modals/NewGroupModal";
import SendRequestModal from "../modals/SendRequestModal";
import CalculatorModal from "../modals/CalculatorModal";
import '../../../App.css'; 



function QuickActions({onAddExpense, onAddGroup}) {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  

  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
  };

  // Helper to render the right modal content
  const renderModalContent = () => {
    switch (modalType) {
      case "expenses":
        return <SplitBillModal onClose={handleCloseModal} onAddExpense={onAddExpense}/>;
      case "group":
        return <NewGroupModal onClose={handleCloseModal} onAddGroup={onAddGroup}/>;
      case "request":
        return <SendRequestModal onClose={handleCloseModal} onAddExpense={onAddExpense}/>;
      case "calculator":
        return <CalculatorModal onClose={handleCloseModal} onAddExpense={onAddExpense}/>;
      default:
        return null;
    }
  };

  return (
    <div className="quick-actions-section">
      
      <div className="quick-actions-card">
        <div className="d-flex flex-wrap justify-content-between gap-3">
          <button className="btn quick-action-btn flex-fill" onClick={() => handleOpenModal("expenses")}>
            💸 Expenses
          </button>
          <button className="btn quick-action-btn flex-fill" onClick={() => handleOpenModal("group")}>
            👥 New Group
          </button>
          <button className="btn quick-action-btn flex-fill" onClick={() => handleOpenModal("request")}>
            📲 Send Request
          </button>
          <button className="btn quick-action-btn flex-fill" onClick={() => handleOpenModal("calculator")}>
            🧮 Calculator
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalType === "expenses" && "Expenses"}
                  {modalType === "group" && "New Group"}
                  {modalType === "request" && "Send Request"}
                  {modalType === "calculator" && "Calculator"}
                </h5>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body">{renderModalContent()}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default QuickActions;